/* global themeTranslations */

/**
 * Retrieves a translated string if available or returns the original text.
 *
 * @param {string} text The string to be translated.
 * @return {string} The translated string if found, otherwise the original string.
 */
export function __( text ) {

	if (
		typeof themeTranslations !== 'undefined' &&
		themeTranslations.translations &&
		themeTranslations.translations[text]
	) {

		return themeTranslations.translations[text];

	}

	return text;

}
